interface FileData {
  id?: number;
  fileGroupId?: number;
  fileTypeId?: number;
  parentFileId?: number;
  file?: string;
  name?: string;
  size?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;
}

export class File {
  public static getNonTranslatableFields(): string[] { return ['id', 'fileGroupId', 'fileTypeId', 'parentFileId', 'file', 'name', 'size', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'fileGroupId', 'fileTypeId', 'parentFileId', 'file', 'name', 'size', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  fileGroupId?: number;
  fileTypeId?: number;
  parentFileId?: number;
  file?: string;
  name?: string;
  size?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  public static fromAPI(data: FileData): File {
    return new File(data);
  }

  public static fromAPIList(data: FileData[]): File[] {
    return data.map((item) => File.fromAPI(item));
  }

  constructor({id, fileGroupId, fileTypeId, parentFileId, file, name, size, createDate, createrId, updateDate, updaterId, deleteDate, deleterId}: FileData) {
    this.id = id;
    this.fileGroupId = fileGroupId;
    this.fileTypeId = fileTypeId;
    this.parentFileId = parentFileId;
    this.file = file;
    this.name = name;
    this.size = size;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
  }

  public toJson(): FileData {
    return {
      id: this.id,
      fileGroupId: this.fileGroupId,
      fileTypeId: this.fileTypeId,
      parentFileId: this.parentFileId,
      file: this.file,
      name: this.name,
      size: this.size,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId,
    };
  }
}
